import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DjPsycho} from "../DjPsycho";
import {TimelineLite} from "gsap";
import {IInfectedPosition, INeighboursData} from "../server/IDjPsychoData";
import {DjPsychoSymbol} from "../reels/DjPsychoSymbol";
import {DjPsychoSound} from "../sound/DjPsychoSound";

export class DjPsychoXZRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return (DjPsycho.model.xZData.length > 0);
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const tl: TimelineLite = new TimelineLite({
                delay: 0.2,
                onComplete: () => {
                    controller.finish();
                }
            }),
            xZData: INeighboursData[] = DjPsycho.model.xZData;

        tl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(tl);
            });

            // #153
            DjPsycho.soundPlayer.playSound(DjPsychoSound.FEATURE_BITE);
        }, 0);

        xZData.forEach((xZ: INeighboursData) => {
            tl.add([
                DjPsycho.xWords.playWordAnimation(xZ.origin.reelId, xZ.origin.symId, "X_Cross"),
                DjPsycho.xSymTransform.playXSymTransformAnimation(xZ.origin.reelId, xZ.origin.symId, "Xz")
            ], 0);

            xZ.infectedPositions.forEach((infect: IInfectedPosition) => {
                tl.add(DjPsycho.xZView.playXZAnimation(infect.reelId, infect.symId, infect.angle), (15 / 30));

                let infectSymbol: DjPsychoSymbol = DjPsycho.reelView.getVisibleSymbolAt(infect.reelId, infect.symId);
                if (infectSymbol.symbolName !== "xS" && infect.symName === "W") {
                    tl.add(() => {
                        infectSymbol.updateTexture(infect.symName);
                    }, (20 / 30));
                } else {
                    tl.add(infectSymbol.doSymbolDouble(infect.symName, infect.reelId, infect.symId, false), (20 / 30));
                }
            });
            tl.add(() => {
                DjPsycho.reelView.getVisibleSymbolAt(xZ.origin.reelId, xZ.origin.symId).updateTexture(xZ.origin.symName);
            }, (25 / 30));
        });
    }

    private onSkip(tl: TimelineLite): void {
        tl.totalProgress(1);
    }
}